/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CheckOut/view.blocks to change it.
import * as fromData from 'Simple/Data'
import CheckOutAction from 'DesignSystem/CheckOutAction/index'
import React from 'react'
import TysiaButtonWithText from 'DesignSystem/TysiaButtonWithText/index'



/** @type {import('Simple/types.js').View} */
export default function CheckOut({
  children,
  viewPath = "/App/Account/WaitingRoom/Content/Content/Checkout/Appointments/Content/Appointment/StateOrAction/CheckOut"
  
}) {
let appointmentBookingIdValueData = fromData.useDataValue({ viewPath,
context: 'appointment_booking',
path: '_id',
})
  return (<React.Fragment
>
<CheckOutAction
  viewPath={`${viewPath}/CheckOutAction`}
 data="appointment_booking._id"
 appointmentBookingId={appointmentBookingIdValueData}
>
{childProps => (
<TysiaButtonWithText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonWithText`}
 size="small"
 text="Check out"
/>
)}
</CheckOutAction>
{children}
</React.Fragment>)
}